const CODES = {
  "ATA": "AQ",
  "GRL": "GL",
  "AGO": "AO",
  "ATF": "TF",
  "AUT": "AT",
  "BEL": "BE",
  "BGR": "BG",
  "HUN": "HU",
  "GRC": "GR",
  "DEU": "DE",
  "DNK": "DK",
  "ITA": "IT",
  "IRL": "IE",
  "ESP": "ES",
  "CYP": "CY",
  "LUX": "LU",
  "LVA": "LV",
  "LTU": "LT",
  "MLT": "MT",
  "NLD": "NL",
  "PRT": "PT",
  "POL": "PL",
  "ROU": "RO",
  "SVN": "SI",
  "SVK": "SK",
  "FRA": "FR",
  "FIN": "FI",
  "HRV": "HR",
  "CZE": "CZ",
  "SWE": "SE",
  "EST": "EE",
  ABW: "AW",
  AFG: "AF",
  AIA: "AI",
  ALA: "AX",
  ALB: "AL",
  AND: "AD",
  ANT: "AN",
  ARE: "AE",
  ARG: "AR",
  ARM: "AM",
  ASM: "AS",
  ATG: "AG",
  AUS: "AU",
  AZE: "AZ",
  BDI: "BI",
  BEN: "BJ",
  BFA: "BF",
  BGD: "BD",
  BHR: "BH",
  BHS: "BS",
  BIH: "BA",
  BLM: "BL",
  BLR: "BY",
  BLZ: "BZ",
  BMU: "BM",
  BOL: "BO",
  BRA: "BR",
  BRB: "BB",
  BRN: "BN",
  BTN: "BT",
  BVT: "BV",
  BWA: "BW",
  CAF: "CF",
  CAN: "CA",
  CCK: "CC",
  CHE: "CH",
  CHL: "CL",
  CHN: "CN",
  CIV: "CI",
  CMR: "CM",
  COD: "CD",
  COG: "CG",
  COK: "CK",
  COL: "CO",
  COM: "KM",
  CPV: "CV",
  CRI: "CR",
  CUB: "CU",
  CUW: "CW",
  CXR: "CX",
  CYM: "KY",
  DJI: "DJ",
  DMA: "DM",
  DOM: "DO",
  DZA: "DZ",
  ECU: "EC",
  EGY: "EG",
  ERI: "ER",
  ETH: "ET",
  FJI: "FJ",
  FLK: "FK",
  FRO: "FO",
  FSM: "FM",
  GAB: "GA",
  GBR: "GB",
  GEO: "GE",
  GGY: "GG",
  GHA: "GH",
  RUS: "RU",
  PAK: "PK",
  SLV: "SV",
  ZWE: "ZW",
  ZMB: "ZM",
  ZAF: "ZA",
  YEM: "YE",
  WSM: "WS",
  WLF: "WF",
  VUT: "VU",
  VNM: "VN",
  VIR: "VI",
  VGB: "VG",
  VEN: "VE",
  VCT: "VC",
  VAT: "VA",
  UZB: "UZ",
  USA: "US",
  URY: "UY",
  UMI: "UM",
  UKR: "UA",
  UGA: "UG",
  TZA: "TZ",
  TWN: "TW",
  TUV: "TV",
  TUR: "TR",
  TUN: "TN",
  TTO: "TT",
  TON: "TO",
  TLS: "TL",
  TKM: "TM",
  TKL: "TK",
  TJK: "TJ",
  THA: "TH",
  TGO: "TG",
  TCD: "TD",
  TCA: "TC",
  SYR: "SY",
  SYC: "SC",
  SXM: "SX",
  SWZ: "SZ",
  SUR: "SR",
  STP: "ST",
  SSD: "SS",
  SRB: "RS",
  GIB: "GI",
  GIN: "GN",
  GLP: "GP",
  GMB: "GM",
  GNB: "GW",
  GNQ: "GQ",
  GRD: "GD",
  GTM: "GT",
  GUF: "GF",
  GUM: "GU",
  GUY: "GY",
  HKG: "HK",
  HMD: "HM",
  HND: "HN",
  HTI: "HT",
  IDN: "ID",
  IMN: "IM",
  IND: "IN",
  IOT: "IO",
  IRN: "IR",
  IRQ: "IQ",
  ISR: "IL",
  JPN: "JP",
  JAM: "JM",
  JEY: "JE",
  JOR: "JO",
  KAZ: "KZ",
  KEN: "KE",
  KGZ: "KG",
  KHM: "KH",
  KIR: "KI",
  KNA: "KN",
  KOR: "KR",
  KWT: "KW",
  LAO: "LA",
  LBN: "LB",
  LBY: "LY",
  LCA: "LC",
  LIE: "LI",
  LKA: "LK",
  LSO: "LS",
  MAC: "MO",
  MAF: "MF",
  MAR: "MA",
  SPM: "PM",
  SOM: "SO",
  SMR: "SM",
  SLE: "SL",
  SLB: "SB", 
  SJM: "SJ",
  SHN: "SH",
  SGS: "GS",
  SGP: "SG",
  SEN: "SN",
  SDN: "SD",
  SAU: "SA",
  RWA: "RW",
  QAT: "QA",
  PYF: "PF",
  PSE: "PS", 
  PRY: "PY",
  PRK: "KP",
  PRI: "PR",
  PNG: "PG",
  PLW: "PW",
  PER: "PE",
  REU: "RE",
  PHL: "PH",
  PCN: "PN",
  PAN: "PA",
  OMN: "OM",
  NZL: "NZ",
  NRU: "NR",
  NPL: "NP",
  NOR: "NO",  
  MCO: "MC",
  MDA: "MD",
  MDG: "MG",
  MDV: "MV",
  MEX: "MX",
  MHL: "MH",
  MKD: "MK",
  MLI: "ML",
  MMR: "MM",
  MNE: "ME",
  MNG: "MN",
  MNP: "MP",
  MOZ: "MZ",
  MRT: "MR",
  MSR: "MS",
  MTQ: "MQ",
  MUS: "MU",
  MWI: "MW",
  MYS: "MY",
  MYT: "YT",
  NAM: "NA",
  NCL: "NC",
  NER: "NE",
  NFK: "NF",
  NGA: "NG",
  NIC: "NI",
  NIU: "NU",
  ISL: "IS",
  LBR: "LR",
  
};

export function ISO2CDbyISO3CD(codeISO3: string): string {
  return CODES[codeISO3] || codeISO3;
}